import React from "react";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "@/contexts/AdminAuthContext";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Menu, LogOut } from "lucide-react";

export function Header({ onMenuClick, isMobile }) {
  const { user, logout } = useAdminAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  const getRoleBadgeVariant = (role) => {
    switch (role) {
      case "super_admin":
        return "destructive";
      case "admin":
        return "default";
      case "operator":
        return "secondary";
      default:
        return "outline";
    }
  };

  return (
    <header className="sticky top-0 z-40 border-b border-soft-gray/20 bg-warm-white safe-top">
      <div className="flex h-14 items-center justify-between px-3 sm:px-4 md:px-6">
        <div className="flex items-center gap-2 sm:gap-3">
          {/* Hamburger menu for mobile */}
          {isMobile && (
            <button
              onClick={onMenuClick}
              className="p-2 -ml-2 hover:bg-earth-neutral rounded-lg transition-colors touch-target"
              aria-label="Toggle menu"
            >
              <Menu className="w-6 h-6 text-charcoal" />
            </button>
          )}
          <img
            src="/impleo-logo.svg"
            alt="Impleo"
            className="h-6 md:h-8"
          />
          <span className="hidden xs:inline text-xs font-semibold px-2 py-1 rounded-md bg-deep-teal/10 text-deep-teal border border-deep-teal/20">
            Admin
          </span>
        </div>

        <div className="flex items-center gap-2 sm:gap-4">
          {user && (
            <>
              <div className="flex items-center gap-2">
                {/* Hide email on mobile, show only on sm+ */}
                <span className="hidden sm:inline text-sm text-soft-gray truncate max-w-[150px] md:max-w-none">
                  {user.email}
                </span>
                <Badge variant={getRoleBadgeVariant(user.role)} className="text-xs whitespace-nowrap">
                  {user.role?.replace("_", " ")}
                </Badge>
                {user.isBackupAuth && (
                  <Badge variant="warning" className="hidden sm:inline">Emergency</Badge>
                )}
              </div>
              <Button variant="outline" size="sm" onClick={handleLogout} className="touch-target">
                <span className="hidden sm:inline">Logout</span>
                <LogOut className="w-4 h-4 sm:hidden" />
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
